import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'remixicon/fonts/remixicon.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { applyTenantFromJwtIfMissing } from '@/security/Axios';

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>
// );

// Optional debug
window.__DEBUG__ = true;

applyTenantFromJwtIfMissing();
// After
root.render(<App />);

reportWebVitals();
